import { obterParametrosDaURL } from "../../../../functions";
import { api } from "../../api";
import { ApiException } from "../../api-exception";

export const AlterarStatusMensagemEUsuarioOrigemEDestinoPorId = async (
  sequencial: number
) => {
  const { token } = obterParametrosDaURL();

  try {
    await api.put(`/alterarstatus_usuariosolicitacaosenha`, undefined, {
      headers: { token, id: String(sequencial) },
    });
  } catch (erro) {
    throw new ApiException(
        erro,
        "Erro ao alterar status da solicitação!"
    );
  }
};